import { Component } from '@theme/component';
import { CartLinesUpdateEvent } from '@shopify/events';

let protectionPending = false;
let lastAutomaticAttempt = '';

class CartProtectionComponent extends Component {
  #busy = false;
  connectedCallback() {
    super.connectedCallback();
    this.syncProtection();
  }
  updatedCallback() {
    super.updatedCallback();
    this.syncProtection();
  }
  syncProtection() {
    if (protectionPending || this.#busy) return;
    const count = Number(this.dataset.merchandiseCount);
    const quantity = Number(this.dataset.protectionQuantity);
    const choice = this.dataset.choice;
    const desired = count > 0 && choice !== 'off' ? 1 : 0;
    if (quantity === desired) return;
    const signature = `${this.dataset.variantId}:${count}:${quantity}:${choice}`;
    if (lastAutomaticAttempt === signature) return;
    lastAutomaticAttempt = signature;
    this.#updateProtection(desired);
  }
  toggleProtection() {
    const button = this.refs.toggle;
    if (!(button instanceof HTMLButtonElement)) return;
    const quantity = button.getAttribute('aria-checked') === 'true' ? 0 : 1;
    this.#updateProtection(quantity, quantity ? 'on' : 'off');
  }
  async #updateProtection(quantity, choice) {
    if (this.#busy || protectionPending) return;
    const button = this.refs.toggle;
    if (!(button instanceof HTMLButtonElement)) return;
    this.#busy = true;
    protectionPending = true;
    button.disabled = true;
    this.refs.error.hidden = true;
    const checkout = this.closest('.cart-drawer__summary')?.querySelector('[name="checkout"]');
    const checkoutWasDisabled = checkout?.disabled;
    if (checkout) checkout.disabled = true;
    const variant = this.dataset.variantId;
    const pending = CartLinesUpdateEvent.createPromise();
    pending.promise.catch(() => {});
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: quantity ? 'add' : 'remove', context: 'cart',
      lines: [{ id: variant, quantity }], promise: pending.promise,
    }));
    try {
      const body = { updates: { [variant]: quantity }, sections: ['cart-drawer-section'], sections_url: location.pathname };
      if (choice) body.attributes = { avenue20_protection: choice };
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const cart = await response.json();
      if (!response.ok || cart.errors) throw new Error('Cart update failed');
      button.setAttribute('aria-checked', String(quantity > 0));
      this.dataset.protectionQuantity = String(quantity);
      if (choice) this.dataset.choice = choice;
      protectionPending = false;
      pending.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {
        sections: cart.sections, items: cart.items, itemCount: cart.item_count,
        source: 'cart-protection-component', didError: false,
      } });
    } catch (error) {
      pending.reject(error);
      this.refs.error.hidden = false;
    } finally {
      protectionPending = false;
      this.#busy = false;
      button.disabled = false;
      if (checkout) checkout.disabled = Boolean(checkoutWasDisabled);
    }
  }
}
if (!customElements.get('cart-protection-component')) customElements.define('cart-protection-component', CartProtectionComponent);
